/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompositeClient = void 0;

var _client = require("./client");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A {@link Client} that delegates requests to case-specific client implementations.
 *
 * @see QueryingClient
 * @see SubscribingClient
 * @see CommandingClient
 */
var CompositeClient = /*#__PURE__*/function (_Client) {
  _inherits(CompositeClient, _Client);

  var _super = _createSuper(CompositeClient);

  function CompositeClient(querying, subscribing, commanding) {
    var _this;

    _classCallCheck(this, CompositeClient);

    _this = _super.call(this);
    /**
     * @type QueryingClient
     *
     * @private
     */

    _this._querying = querying;
    /**
     * @type SubscribingClient
     *
     * @private
     */

    _this._subscribing = subscribing;
    /**
     * @type CommandingClient
     *
     * @private
     */

    _this._commanding = commanding;
    return _this;
  }
  /**
   * @override
   */


  _createClass(CompositeClient, [{
    key: "select",
    value: function select(entityType) {
      return this._querying.select(entityType, this);
    }
    /**
     * @override
     */

  }, {
    key: "read",
    value: function read(query) {
      return this._querying.read(query);
    }
    /**
     * @override
     */

  }, {
    key: "newQuery",
    value: function newQuery() {
      return this._querying.newQuery();
    }
    /**
     * @override
     */

  }, {
    key: "subscribeTo",
    value: function subscribeTo(entityType) {
      return this._subscribing.subscribeTo(entityType, this);
    }
    /**
     * @override
     */

  }, {
    key: "subscribeToEvent",
    value: function subscribeToEvent(eventType) {
      return this._subscribing.subscribeToEvent(eventType, this);
    }
    /**
     * @override
     */

  }, {
    key: "subscribe",
    value: function subscribe(topic) {
      return this._subscribing.subscribe(topic);
    }
    /**
     * @override
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(topic) {
      return this._subscribing.subscribeToEvents(topic);
    }
    /**
     * @override
     */

  }, {
    key: "newTopic",
    value: function newTopic() {
      return this._subscribing.newTopic();
    }
    /**
     * @override
     */

  }, {
    key: "command",
    value: function command(commandMessage) {
      return this._commanding.command(commandMessage, this);
    }
    /**
     * @override
     */

  }, {
    key: "post",
    value: function post(command, onAck) {
      this._commanding.post(command, onAck);
    }
  }]);

  return CompositeClient;
}(_client.Client);

exports.CompositeClient = CompositeClient;
//# sourceMappingURL=composite-client.js.map